import { useNavigate } from 'react-router-dom'
import { ArrowLeft } from 'lucide-react'
import { PageContainer } from '@/components/layout/PageContainer'
import { Button } from '@/components/ui/button'
import { StorefrontSettingsGuard } from './StorefrontSettingsGuard'
import { LoginVerificationSettings } from './LoginVerificationSettings'
import { ProfileFieldsSettings } from './ProfileFieldsSettings'

export function CustomerAccountsPage() {
  const navigate = useNavigate()

  return (
    <StorefrontSettingsGuard>
      <PageContainer>
        <div className="p-6 space-y-6">
          <div className="flex items-center gap-3">
            <Button
              variant="ghost"
              size="icon"
              className="rounded-full"
              onClick={() => navigate('/storefront/settings')}
            >
              <ArrowLeft className="w-4 h-4" />
            </Button>
            <div>
              <h2 className="text-2xl font-semibold">Customer Accounts</h2>
              <p className="text-sm text-muted-foreground">
                Login, OTP verification, and profile fields
              </p>
            </div>
          </div>

          <LoginVerificationSettings />
          <ProfileFieldsSettings />
          <p className="text-xs text-muted-foreground pl-4">
            Configure which fields to collect after LINE login verification.
          </p>
        </div>
      </PageContainer>
    </StorefrontSettingsGuard>
  )
}
